import { Body2, Caption } from '@cian/ui-kit/typography';

import type { IBuildingCompany } from 'shared/types/buildingCard';

import style from './style.css';

export interface IBuildingStakeholdersProps {
  developer: IBuildingCompany | null;
  managementCompany: IBuildingCompany | null;
}

const Stakeholder = ({ title, company }: { title: string; company: IBuildingCompany }) => (
  <div className={style['item']}>
    <dt>
      <Caption color="text-secondary-default">{title}</Caption>
    </dt>
    <dd className={style['company']}>
      {company.logoUrl ? (
        <img className={style['logo']} src={company.logoUrl} alt={company.name} />
      ) : (
        <span className={`${style['logo']} ${style['letter']}`} data-name="StakeholderLetter">
          {company.name.charAt(0).toUpperCase()}
        </span>
      )}
      <Body2>{company.name}</Body2>
    </dd>
  </div>
);

/** Застройщик и управляющая компания — как `stakeholder.html` монолита */
export const BuildingStakeholders = ({ developer, managementCompany }: IBuildingStakeholdersProps) => {
  if (!developer && !managementCompany) {
    return null;
  }

  return (
    <dl className={style['container']} data-name="BuildingStakeholders">
      {developer && <Stakeholder title="Застройщик" company={developer} />}
      {managementCompany && <Stakeholder title="Управляющая компания" company={managementCompany} />}
    </dl>
  );
};
